<app-spinner *ngIf="loading"></app-spinner>

<div *ngIf="!loading">
  <table>
    <tbody>
    <tr class="table-column-header">
      <th class="header-cell"></th>
      <th class="header-cell" *ngFor="let action of actions">{{action.value}}</th>
    </tr>
    <tr class="table-row" *ngFor="let component of components">
      <td class="header-row">
        <div>{{component.value}}</div>
      </td>
      <td class="table-cell" *ngFor="let action of actions">
        <div class="table-cell-content" *ngIf="getPrivilege(action, component) as privilege">
          <app-privilege-checkbox *ngIf="isSettable(action, component)"
                                  [privilege]="getPrivilege(action, component)"
                                  (checkboxChangeEvent)="checkboxChange()"
                                  [editMode]="editMode">
          </app-privilege-checkbox>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>



// WEBPACK FOOTER //
// ./src/app/components/checkbox-table/checkbox-table.component.html